export default __webpack_public_path__ + "images/f422429f89d040fec99ae31d6d84497c.svg";